import { render, staticRenderFns } from "./activityChinese.vue?vue&type=template&id=7268440a&scoped=true"
import script from "./activityChinese.vue?vue&type=script&lang=js"
export * from "./activityChinese.vue?vue&type=script&lang=js"
import style0 from "./activityChinese.vue?vue&type=style&index=0&id=7268440a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7268440a",
  null
  
)

export default component.exports